module.exports = __webpack_public_path__ + "img/cn_logo2.b99aeb3a.png";